module.exports = __webpack_public_path__ + "static/media/minus.67d77d54.svg";